import { apiSlice } from 'store/api/apiSlice';

import { IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';

interface IBuyBarVariantsParams {
  id: number;
  selectedCountryCode: string;
}

export const buyBarVariantsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBuyBarVariants: builder.query<IBuyBarProductVariant[], IBuyBarVariantsParams>({
      query: ({ id, selectedCountryCode }) => ({
        url: `/web-api/v1/product_variants/buy_bar_data?productTemplateId=${id}&countryCode=${selectedCountryCode}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchBuyBarVariantsQuery } = buyBarVariantsApi;
